// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ClassroomEducator,
    ClassroomEducatorFromJSON,
    ClassroomEducatorToJSON,
    ClassroomMembership,
    ClassroomMembershipFromJSON,
    ClassroomMembershipToJSON,
    ClassroomObjectPermissions,
    ClassroomObjectPermissionsFromJSON,
    ClassroomObjectPermissionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface Classroom
 */
export interface Classroom {
    /**
     * 
     * @type {string}
     * @memberof Classroom
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof Classroom
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Classroom
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Classroom
     */
    subject: string;
    /**
     * 
     * @type {number}
     * @memberof Classroom
     */
    maxStudents: number;
    /**
     * 
     * @type {string}
     * @memberof Classroom
     */
    readonly imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Classroom
     */
    readonly joinCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Classroom
     */
    archived: boolean;
    /**
     * 
     * @type {ClassroomObjectPermissions}
     * @memberof Classroom
     */
    permissions?: ClassroomObjectPermissions;
    /**
     * 
     * @type {Array<ClassroomMembership>}
     * @memberof Classroom
     */
    readonly members?: Array<ClassroomMembership>;
    /**
     * 
     * @type {Array<ClassroomEducator>}
     * @memberof Classroom
     */
    educators?: Array<ClassroomEducator>;
    /**
     * 
     * @type {number}
     * @memberof Classroom
     */
    readonly membershipsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof Classroom
     */
    readonly itemsCount?: number;
}

export function ClassroomFromJSON(json: any): Classroom {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': json['description'],
        'subject': json['subject'],
        'maxStudents': json['max_students'],
        'imageUrl': !exists(json, 'image_url') ? undefined : json['image_url'],
        'joinCode': !exists(json, 'join_code') ? undefined : json['join_code'],
        'archived': json['archived'],
        'permissions': !exists(json, 'permissions') ? undefined : ClassroomObjectPermissionsFromJSON(json['permissions']),
        'members': !exists(json, 'members') ? undefined : (json['members'] as Array<any>).map(ClassroomMembershipFromJSON),
        'educators': !exists(json, 'educators') ? undefined : (json['educators'] as Array<any>).map(ClassroomEducatorFromJSON),
        'membershipsCount': !exists(json, 'memberships_count') ? undefined : json['memberships_count'],
        'itemsCount': !exists(json, 'items_count') ? undefined : json['items_count'],
    };
}

export function ClassroomToJSON(value?: Classroom): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'description': value.description,
        'subject': value.subject,
        'max_students': value.maxStudents,
        'archived': value.archived,
        'permissions': ClassroomObjectPermissionsToJSON(value.permissions),
        'educators': value.educators === undefined ? undefined : (value.educators as Array<any>).map(ClassroomEducatorToJSON),
    };
}


